import React from 'react'
import PropTypes from 'prop-types'
import { TonalButton } from 'components/empty-page-state'
import AddToPhotosOutlinedIcon from 'components/material-symbol/icons/AddToPhotos'
import EventIcon from 'components/material-symbol/icons/Event'
import { gtmEvent } from 'lib/gtm'
import { OFFERINGS_PATH } from 'pages/pga-coach/bookings/offerings/routes'
import useAddBookingAction from './use-add-booking-action'

export const AddOfferingButton = ({
  children = 'Add offering',
  formLabel,
  ...props
}) => (
  <TonalButton
    startIcon={<AddToPhotosOutlinedIcon />}
    to={OFFERINGS_PATH}
    onClick={() =>
      gtmEvent({
        event: 'formSubmit',
        formCategory: 'add-offering',
        formAction: 'clicked-add-offering-button',
        formLabel,
      })
    }
    {...props}
  >
    {children}
  </TonalButton>
)

AddOfferingButton.propTypes = {
  children: PropTypes.node,
  formLabel: PropTypes.string.isRequired,
}

// A coach with no offering has nothing to book into yet, so the empty-state
// action sends them to create one instead.
const BookingActionButton = ({ formLabel, hasOffering = true }) => {
  const addBooking = useAddBookingAction({ formLabel })

  if (!hasOffering) return <AddOfferingButton formLabel={formLabel} />

  return (
    <TonalButton startIcon={<EventIcon />} onClick={addBooking.onClick}>
      Add booking
    </TonalButton>
  )
}

BookingActionButton.propTypes = {
  formLabel: PropTypes.string.isRequired,
  hasOffering: PropTypes.bool,
}

export default BookingActionButton
